export default "/_next/static/chunks/fonts/GraphikBold-e78d3d4f87bc060c0a1a6997adba4c77.otf";